import { Backend } from '@/_axios';

export default {
  list() {
    return Backend.get('deposits/types');
  },
};
